<template>
  <div class="mini-place-card" @click="clickMiniPlaceCard">
    <div class="category-icon-container">
      <img class="category-icon" :src="categoryIconPath !== '' ? categoryIconPath : util.getImagePath('pin_blue@2x.png')" :srcset="categoryIconHdPath !== '' ? `${categoryIconHdPath} 2x` : util.getImageSet('pin_blue')" loading="lazy">
      <img class="fav-icon" :src="util.getImagePath('star_orange@2x.png')" :srcset="util.getImageSet('star_orange')" v-if="isFav">
      <img class="create-icon" :src="util.getImagePath('create_orange@2x.png')" :srcset="util.getImageSet('create_orange')" v-if="!isFav">
    </div>
    <div class="detail">
      <div class="name">{{ ($i18n.locale === 'th' ? nameTh : nameEn).replace(/undefined/g, '') }}</div>
      <!-- <iframe ref="promptpai-id-iframe" @load="bindPromptPaiIdIframe" :src="`https://promptpai-test.longdo.com/ws/promptpai-link?pp_id=${code}&code_type=id&size=normal&button_style=button&theme=light&locale=${$i18n.locale}`" width="96" height="22" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"/> -->
      <PromptPaiSnippetButton :id="code" />
      <!-- <div class="address">{{ $i18n.locale === 'th' ? addressTh : addressEn }}</div> -->
    </div>
    <div class="right-detail">
      <button class="promptpai-icon-button" @click="clickPromptpaiIcon" :class="{clickable: clickable}" v-if="code.length === 8">
        <img :src="util.getImagePath('promptpai_icon@2x.png')" :srcset="util.getImageSet('promptpai_icon')">
      </button>
    </div>
  </div>
</template>

<script>
import PromptPaiSnippetButton from '@/components/PromptPaiSnippetButton.vue'

export default {
  name: 'MiniPlaceCard',
  components: {
    PromptPaiSnippetButton
  },
  props: {
    categoryIconPath: {
      type: String,
      default: ''
    },
    categoryIconHdPath: {
      type: String,
      default: ''
    },
    isFav: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    nameTh: {
      type: String,
      default: ''
    },
    nameEn: {
      type: String,
      default: ''
    },
    addressTh: {
      type: String,
      default: ''
    },
    addressEn: {
      type: String,
      default: ''
    },
    location: {
      type: Object,
      default: undefined
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayCode () {
      var self = this
      if (self.code.length === 8) {
        return self.code.substring(0, 4) + ' ' + self.code.substring(4, 8)
      } else {
        return ''
      }
    }
  },
  methods: {
    clickMiniPlaceCard () {
      var self = this
      self.$emit('clickMiniPlaceCard', self)
    },
    clickPromptpaiIcon () {
      var self = this
      self.$emit('clickPromptpaiIcon', self)
    },
    bindPromptPaiIdIframe () {
      var self = this
      var iframe = self.$refs['promptpai-id-iframe']
      var content = (iframe.contentWindow || iframe.contentDocument)
      if (content.document) {
        content = content.document
      }
      content.querySelector('.pp-snippet-link').addEventListener('click', (e) => {
        e.preventDefault()
        // var textArea = document.createElement("textarea");
        // textArea.value = content.querySelector('.pp-snippet-name').innerHTML
        // document.body.appendChild(textArea)
        // textArea.select()
        // document.execCommand("Copy")
        // textArea.remove()
        // self.isShowCopiedPromptpaiId = true
        // setTimeout(() => {
        //   self.isShowCopiedPromptpaiId = false
        // }, 2000)
        return false
      })
    }
  }
}
</script>

<style scoped>
  .mini-place-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .mini-place-card.clickable:hover {
    background: rgb(227, 227, 227);
  }

  .category-icon-container {
    width: 24px;
    height: 24px;
    margin: auto 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img.category-icon {
    max-width: 24px;
    max-height: 24px;
  }

  .fav-icon,
  .create-icon {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 16px;
    left: 16px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 56px - 60px);
    /* overflow: hidden; */
    padding-top: 0px;
    box-sizing: border-box;
    align-self: center;
  }

  .detail > .name {
    font-weight: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.75;
    text-indent: 2px;
  }

  .detail > .address {
    color: rgb(120, 120, 120);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    text-align: left;
  }

  .right-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 60px;
    overflow: hidden;
    box-sizing: border-box;
  }

  button.promptpai-icon-button {
    width: 32px;
    height: 32px;
    padding: 0px;
    margin: 6px 12px 0px 16px;
    background-color: transparent;
    border: none;
    cursor: default;
    overflow: hidden;
  }

  button.promptpai-icon-button.clickable {
    cursor: pointer;
  }

  .promptpai.icon > img {
    width: 32px;
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MiniPlaceCard.vue